// Shared utilities for PDF processing flows (split, rename, etc.)
import { apiCallErrorHandler } from './common';

export const apiUrl = (path) => `${process.env.REACT_APP_API_URL || ''}${path}`;

export const generateSessionId = () => {
  if (typeof crypto !== 'undefined' && crypto.randomUUID) {
    return crypto.randomUUID();
  }
  // Basic fallback
  return 'sid-' + Math.random().toString(36).slice(2) + Date.now().toString(36);
};

export async function submitFileJob(endpointBase, sessionId, token, fileNames) {
  const response = await fetch(`${apiUrl(endpointBase)}/${sessionId}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`
    },
    body: JSON.stringify({ fileNames })
  });
  if (!response.ok) {
    const text = await response.text().catch(() => '');
    throw new Error(text || 'Failed to submit. Please try again.');
  }
  // Expected shape: { msg: "Done", errors?: { [fileName]: string } }
  return response.json().catch(() => ({}));
}

export async function discardSessionRequest(sessionId, token) {
  const resp = await fetch(`${apiUrl('/file/discard')}/${sessionId}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`
    }
  });
  return resp.ok;
}

export function triggerFileDownload(blob, filename) {
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.URL.revokeObjectURL(url);
}

export async function downloadCompressed(sessionId, token) {
  const response = await fetch(`${apiUrl('/file/download-zip')}/${sessionId}`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`
    }
  });
  if (!response.ok) await apiCallErrorHandler(response, 'Failed to download. Please try again.');
  const blob = await response.blob();
  triggerFileDownload(blob, `${sessionId}.zip`);
  return true;
}

export async function downloadXlsx(sessionId, token) {
  const response = await fetch(`${apiUrl('/file/download-xlsx-done')}/${sessionId}`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`
    }
  });
  if (!response.ok) await apiCallErrorHandler(response, 'Failed to download. Please try again.');
  const blob = await response.blob();
  const disposition = response.headers.get('Content-Disposition');
  const match = disposition && disposition.match(/filename[^;=\n]*=['"]?([^'"\n;]+)['"]?/i);
  const filename = match ? match[1] : `${sessionId}.xlsx`;
  triggerFileDownload(blob, filename);
  return true;
}